"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _CusromUpload = _interopRequireDefault(require("@/components/uploadImg/CusromUpload.vue"));
var _upgradeConfiguration = require("@/api/hierarchicalCommissionAllocation/upgradeConfiguration");
var _ossUpload = require("@/utils/ossUpload");
var _BeginnerCourse = require("@/api/operationManagement/BeginnerCourse");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'BeginnerList',
  components: {
    upload: _CusromUpload.default
  },
  data: function data() {
    return {
      itemKey: 'BeginnerCourseModule',
      moduleManage: false,
      moduleData: [],
      // ------------------
      dialogVisible: false,
      ControlsType: 'add',
      // 控制新增还是编辑
      ruleForm: {
        id: null,
        mainUrl: '',
        fileName: '',
        modeCode: null,
        sortNo: '',
        fileUrl: '',
        status: 1
      },
      rules: {
        mainUrl: [{
          required: true,
          message: '请上传新手教程图',
          trigger: 'blur'
        }],
        fileName: [{
          required: true,
          message: '请输入内容名称',
          trigger: 'blur'
        }],
        modeCode: [{
          required: true,
          message: '请选择所属模块',
          trigger: 'change'
        }],
        sortNo: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }],
        fileUrl: [{
          required: true,
          message: '请上传视频',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }]
      },
      fileList: [],
      // 列表
      tableData: [],
      queryData: {
        fileName: null,
        modeCode: null,
        status: null,
        page: {
          page: 1,
          size: 10
        }
      },
      total: 0,
      uploadStatus: true
    };
  },
  created: function created() {
    this.beginnerTutorialPageList();
    this.getSetting();
  },
  methods: {
    // 模块管理
    onModuleManage: function onModuleManage() {
      this.moduleManage = true;
      this.getSetting();
    },
    onModuleClose: function onModuleClose() {
      this.moduleManage = false;
    },
    onAddModule: function onAddModule() {
      var id;
      if (this.moduleData.length > 0) {
        id = this.moduleData[this.moduleData.length - 1].id + 1;
      } else {
        id = 1;
      }
      this.moduleData.push({
        id: id,
        title: '',
        textColor: '',
        bgColor: ''
      });
    },
    onDelModule: function onDelModule(index) {
      var _this = this;
      this.$confirm('删除模块将清空模块内的内容确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.moduleData.splice(index, 1);
      });
    },
    onModuleVerify: function onModuleVerify() {
      var _this2 = this;
      this.$confirm('是否确认修改模块配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.saveSetting();
      });
    },
    getSetting: function () {
      var _getSetting2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {
                itemKey: this.itemKey
              };
              _context.n = 1;
              return (0, _upgradeConfiguration.getSetting)(params);
            case 1:
              res = _context.v;
              if (res.data !== '') {
                this.moduleData = [];
                this.moduleData = JSON.parse(res.data);
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getSetting() {
        return _getSetting2.apply(this, arguments);
      }
      return getSetting;
    }(),
    saveSetting: function () {
      var _saveSetting2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                itemKey: this.itemKey,
                itemValue: JSON.stringify(this.moduleData)
              };
              _context2.n = 1;
              return (0, _upgradeConfiguration.saveSetting)(params);
            case 1:
              res = _context2.v;
              if (res.data) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.getSetting();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function saveSetting() {
        return _saveSetting2.apply(this, arguments);
      }
      return saveSetting;
    }(),
    // ------------------------------------
    // 新增内容
    onAddContent: function onAddContent() {
      this.dialogVisible = true;
      this.ControlsType = 'add';
    },
    // 编辑
    onEditor: function onEditor(data) {
      console.log('data', data);
      this.dialogVisible = true;
      this.ControlsType = 'editor';
      this.ruleForm = {
        id: data.id,
        mainUrl: data.mainUrl,
        fileName: data.fileName,
        modeCode: Number(data.modeCode),
        sortNo: data.sortNo,
        fileUrl: data.fileUrl,
        status: data.status
      };
    },
    onClose: function onClose() {
      this.dialogVisible = false;
      this.ruleForm = {
        id: null,
        mainUrl: '',
        fileName: '',
        modeCode: null,
        sortNo: '',
        fileUrl: '',
        status: 1
      };
      this.uploadStatus = true;
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(file) {
        var pictureUrl;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.uploadStatus = false;
              _context3.n = 1;
              return (0, _ossUpload.uploadOSS)(file.file);
            case 1:
              pictureUrl = _context3.v;
              this.ruleForm.fileUrl = pictureUrl;
              this.uploadStatus = true;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    handleChange: function handleChange(file, fileList) {
      this.fileList = [];
    },
    handleRemove: function handleRemove(file, fileList) {
      this.ruleForm.fileUrl = '';
    },
    submitForm: function submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.$confirm('是否确认新增内容?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this3.beginnerTutorialSaveOrUpdate();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm() {
      this.$refs.ruleForm.resetFields();
      this.showBoole = false;
    },
    onPictureAddress: function onPictureAddress(data) {
      this.ruleForm[data.name] = data.pictureUrl;
    },
    beginnerTutorialSaveOrUpdate: function () {
      var _beginnerTutorialSaveOrUpdate2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = {
                id: this.ControlsType !== 'add' ? this.ruleForm.id : null,
                mainUrl: this.ruleForm.mainUrl,
                fileName: this.ruleForm.fileName,
                modeCode: this.ruleForm.modeCode,
                sortNo: this.ruleForm.sortNo,
                fileUrl: this.ruleForm.fileUrl,
                status: this.ruleForm.status
              };
              _context4.n = 1;
              return (0, _BeginnerCourse.beginnerTutorialSaveOrUpdate)(params);
            case 1:
              res = _context4.v;
              if (res.data) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.dialogVisible = false;
                this.beginnerTutorialPageList();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              console.log(_t3);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function beginnerTutorialSaveOrUpdate() {
        return _beginnerTutorialSaveOrUpdate2.apply(this, arguments);
      }
      return beginnerTutorialSaveOrUpdate;
    }(),
    // ----列表-------
    beginnerTutorialPageList: function () {
      var _beginnerTutorialPageList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                fileName: this.queryData.fileName,
                modeCode: this.queryData.modeCode,
                status: this.queryData.status,
                page: {
                  page: this.queryData.page.page,
                  size: this.queryData.page.size
                }
              };
              console.log('params-------', params);
              _context5.n = 1;
              return (0, _BeginnerCourse.beginnerTutorialPageList)(params);
            case 1:
              res = _context5.v;
              console.log('res-------', res);
              if (res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              console.log(_t4);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function beginnerTutorialPageList() {
        return _beginnerTutorialPageList2.apply(this, arguments);
      }
      return beginnerTutorialPageList;
    }(),
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.beginnerTutorialPageList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.beginnerTutorialPageList();
    },
    search: function search() {
      this.beginnerTutorialPageList();
    },
    rest: function rest() {
      this.queryData = {
        fileName: null,
        modeCode: null,
        status: null,
        page: {
          page: 1,
          size: 10
        }
      };
      this.beginnerTutorialPageList();
    },
    onDel: function onDel(data) {
      var _this4 = this;
      this.$confirm('是否确认删除此内容?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.beginnerTutorialDeleteById(data.id);
      });
    },
    beginnerTutorialDeleteById: function () {
      var _beginnerTutorialDeleteById2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(id) {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                id: id
              };
              _context6.n = 1;
              return (0, _BeginnerCourse.beginnerTutorialDeleteById)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.beginnerTutorialPageList();
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t5 = _context6.v;
              console.log(_t5);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function beginnerTutorialDeleteById(_x2) {
        return _beginnerTutorialDeleteById2.apply(this, arguments);
      }
      return beginnerTutorialDeleteById;
    }()
  }
};